import { render, staticRenderFns } from "./Shipped.vue?vue&type=template&id=474a3125&scoped=true&"
import script from "./Shipped.vue?vue&type=script&lang=js&"
export * from "./Shipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a3125",
  null
  
)

export default component.exports